module.exports = "/images/deng-qing.jpg?05ca5644e29149846a2dfef6600efc41";